import { render, staticRenderFns } from "./MyDownload.vue?vue&type=template&id=97cb2160&scoped=true"
import script from "./MyDownload.vue?vue&type=script&lang=js"
export * from "./MyDownload.vue?vue&type=script&lang=js"
import style0 from "./MyDownload.vue?vue&type=style&index=0&id=97cb2160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cb2160",
  null
  
)

export default component.exports